var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"salesStatistics"}},[_c('h2',[_vm._v("运营额统计")]),_c('echarts-com',{attrs:{"id":"chart","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }